import { z } from 'zod/v4';
import { FileSchema } from '../../files/index.js';
export var ProductService;
(function (ProductService) {
    ProductService["Collection"] = "COLLECTION";
    ProductService["CourtHandling"] = "COURT_HANDLING";
})(ProductService || (ProductService = {}));
export const CreateConnectProductSchema = z.object({
    partnerId: z.uuid(),
    public: z.boolean().optional(),
    name: z.string(),
    logo: FileSchema.nullish(),
    description: z.string(),
    content: z.string(),
    billingModelId: z.uuid().nullish(),
    workflowId: z.uuid().nullish(),
    caseGroupId: z.uuid().nullish(),
    service: z.enum(ProductService),
});
export const CreateConnectProductInputSchema = CreateConnectProductSchema.omit({
    partnerId: true,
});
export const UpdateConnectProductInputSchema = z.object({
    name: z.string().optional(),
    logo: FileSchema.nullish(),
    description: z.string().optional(),
    content: z.string().optional(),
    billingModelId: z.uuid().nullish(),
    workflowId: z.uuid().nullish(),
    caseGroupId: z.uuid().nullish(),
    service: z.enum(ProductService).optional(),
});
//# sourceMappingURL=index.js.map